// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4464":"5d9cf8cc","5060":"5d9cf8cc","6923":"5d9cf8cc","7895":"918fa54e"}[chunkId] + ".chunk.css";
};